import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadSettingEnumLimitedFailed,
  loadSettingEnumLimitedSuccessful,
  loadSettingsByIdBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadSettingEnumLimited(action) {
  try {
    const url = `${BACKEND_URL}/v1/api-scopes`;
    // yield put(loadSettingsByIdBegin());
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadSettingEnumLimitedSuccessful(data?.data));
      yield call(resolveActionPromise(action, data?.data));
    } else {
      yield put(loadSettingEnumLimitedFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadSettingEnumLimitedFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
